// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slider_wrapper__1yFsr","container":"slider_container__2WOWi","shelf":"slider_shelf__cr3t1"};